import { DataTypeProvider } from "@devexpress/dx-react-grid"
import React from "react"
import TimeAgo from 'react-timeago'
import { Chip } from "@mui/material"

// ************************************************************

const DateFormatter = ({ value }) => {
  if (!value || value === "0000-00-00 00:00:00")
    return <></>
  return (
    <b style={{ color: 'darkblue' }}>    
      <TimeAgo date={value} />
    </b>
  )
}
export const DateTypeProvider = props => <DataTypeProvider formatterComponent={DateFormatter} {...props} />

const RowNumFormatter = ({ row }) => {
  return <Chip label={row.row_num} size="small" variant="outlined" />  
}
export const RowNumTypeProvider = props => <DataTypeProvider formatterComponent={RowNumFormatter} {...props} />

const ResellerFormatter = ({ row }) => {
  if (row.reseller_id === -1) return <Chip label="ANY" size="small" variant="outlined" />
  return <>{row.reseller_username || row.reseller_id}</>
}
export const ResellerTypeProvider = props => <DataTypeProvider formatterComponent={ResellerFormatter} {...props} />

const CountryFormatter = ({ value }) => {
  if (!value || value === "") return <Chip label="ANY" size="small" variant="outlined" />
  return <>{value}</>
}
export const CountryTypeProvider = props => <DataTypeProvider formatterComponent={CountryFormatter} {...props} />

// ************************************************************

export default class EcuFwResellerTableProps {
  getTableColumns() {
    return [
      { name: 'row_num',            title: '#',              getCellValue: row => row.row_num },
      { name: 'id',                 title: 'Id',             getCellValue: row => row.id },
      { name: 'ecu_prefix',         title: 'ECU Prefix',     getCellValue: row => row.ecu_prefix },
      { name: 'country_code',       title: 'Country',        getCellValue: row => row.country_code },
      { name: 'reseller_id',        title: 'Reseller',       getCellValue: row => row.reseller_id },
      { name: 'fw_name',            title: 'FW Name',        getCellValue: row => row.fw_name },
      { name: 'note',               title: 'Note',           getCellValue: row => row.note },
      { name: 'created_at',         title: 'Created',        getCellValue: row => row.created_at },
      { name: 'updated_at',         title: 'Updated',        getCellValue: row => row.updated_at },
    ]
  }
  getTableColumnWidths() {
    return [
      { columnName: 'row_num',        width: 80 },
      { columnName: 'id',             width: 70 },
      { columnName: 'ecu_prefix',     width: 150 },
      { columnName: 'country_code',   width: 120 },
      { columnName: 'reseller_id',    width: 180 },
      { columnName: 'fw_name',        width: 220 },
      { columnName: 'note',           width: 200 },
      { columnName: 'created_at',     width: 130 },
      { columnName: 'updated_at',     width: 130 },
    ]
  }
  getTableColumnExtensions() {
    return [
      { columnName: 'row_num',        align: 'right' },
      { columnName: 'id',             align: 'right' },
      { columnName: 'created_at',     align: 'right' },
      { columnName: 'updated_at',     align: 'right' },
    ]
  }
  getTableSortingStateColumnExtensions() {
    return [
      { columnName: 'row_num',        sortingEnabled: false },
    ]
  }
  getTableFilteringStateColumnExtensions() {
    return [
      { columnName: 'row_num',        filteringEnabled: false },
      { columnName: 'id',             filteringEnabled: false },
      { columnName: 'created_at',     filteringEnabled: false },
      { columnName: 'updated_at',     filteringEnabled: false },
    ]
  }
}
